import { EUserRoles } from '@enums/common';

export const allowedRolesDownloadHistory = [
	EUserRoles.platformOwnerAdministrator,
	EUserRoles.networkOperatorKpiViewer,
	EUserRoles.networkOperatorKpiUpdater,
	EUserRoles.networkOperatorThresholdKpiViewer,
	EUserRoles.networkOperatorThresholdKpiUpdater,
	EUserRoles.networkOperatorAlarmManager,
	EUserRoles.networkOperatorAssetEnquirer,
	EUserRoles.networkOperatorAssetViewer,
	EUserRoles.assetOwnerOrganizationAdministrator,
	EUserRoles.assetOwnerViewer,
	EUserRoles.assetOwnerAttributeUpdater,
	EUserRoles.assetOwnerContact,
	EUserRoles.assetOwnerSignatory,
	EUserRoles.assetOwnerManageRequests,
	EUserRoles.assetOwnerApprovalUnit,
	EUserRoles.assetConsumerAssetEnquirer,
	EUserRoles.networkOperatorTelecomSitesViewer,
	EUserRoles.networkOperatorTelecomSitesAttributeUpdater,
	EUserRoles.networkOperatorCmModuleEditor,
	EUserRoles.networkOperatorCmModuleViewer,
	EUserRoles.portalProjectAdministrator,
	EUserRoles.portalProjectMember,
	EUserRoles.smoLightViewer,
	EUserRoles.smoLightUpdater,
];
